<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout"
                               active
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="support()">
                               Support
    </b-nav-item>
    </b-nav>
    </div>
    <div>
    <div class="main-div">
    <div class="login-div">
    <div class="profile-div col-11">
      <h5 class="mt-3 mb-3"> Quotation </h5><br>
      <h5 class="mt-3 mb-3">Please review your below quote and arrange payment. </h5><br>
      <table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" bgcolor="#ffffff" style="width:100%;min-width:100%">
        <tr>
          <td align="center" valign="top">
            <table cellpadding="0" border="0" cellspacing="0" width="100%">
              <tr>
                <td align="left" valign="middle" style="padding:16px 30px">
                  <hr style="height:1px;color:#eaf0f6;background-color:#eaf0f6;border:none;margin:0px;padding:0px">
                  <table cellpadding="0" border="0" cellspacing="0" width="100%">
                    <tr>
                      <td align="left" valign="middle" style="padding:30px 0">
                        <table cellpadding="0" border="0" cellspacing="0" width="100%" valign="middle" style="width:100%;min-width:100%">
                          <tr>
                            <td valign="middle">
                              <table cellpadding="0" border="0" cellspacing="0" width="100%">
                                <tr>
                                  <td align="left" valign="middle" style="padding:0">
                                    <div>
                                      <span>{{company}}</span><br>
                                      <span>{{address}}</span><br>
                                      <span>{{postCode}}</span><br>
                                      <span>{{country}}</span><br>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td valign="middle">
                              <table cellpadding="0" border="0" cellspacing="0" width="100%">
                                <tr>
                                  <td align="right" valign="middle" style="padding:0">
                                    Quote / Invoice #: {{quoteNumber}}<br>
                                    Invoice Date: {{requestDate}}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <hr style="height:1px;color:#eaf0f6;background-color:#eaf0f6;border:none;margin:0px;padding:0px">
                </td>
              </tr>
            </table>
            <table cellpadding="0" border="0" cellspacing="0" width="100%">
              <tr>
                <td align="left" valign="middle" style="padding:16px 30px">
                  <table cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;font-family:Avenir Next,Helvetica,Arial,sans-serif;font-weight:700;color:#425b76;font-size:32px;margin:0">

                      <tr>
                        <td style="padding-top:0px;padding-bottom:20px;text-align:left">Your Facit Smart Count invoice.</td>
                      </tr>

                  </table>
                  <table cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;font-family:Avenir Next,Helvetica,Arial,sans-serif;font-weight:700;color:#425b76;font-size:16px;margin:0">

                      <tr>
                        <td style="padding-top:0px;padding-bottom:14px;text-align:left">Billed to:</td>
                      </tr>

                  </table>
                  <span>
                    <span>{{company}}</span><br>
                    <span>{{address}}</span><br>
                    <span>{{postCode}}</span><br>
                    <span>{{country}}</span><br>
                  </span>
                  <p style="margin:20px 0 0">Due Date: {{requestDate}}</p>
                  <p style="margin:20px 0 0">PO No: {{purchasedOrderNo}}</p>
                </td>
              </tr>
            </table>
            <table cellpadding="0" border="0" cellspacing="0" width="100%">

                <tr>
                  <td align="left" valign="middle" style="padding:16px 30px">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="width:100%;min-width:100%;border-collapse:collapse">

                        <tr bgcolor="#f5f8fa">
                          <th align="left" style="padding:8px 24px;font-size:12px;font-weight:700;text-transform:uppercase;border:1px solid #cbd6e2">Item</th>
                          <th align="center" style="padding:8px 24px;font-size:12px;font-weight:700;text-transform:uppercase;border:1px solid #cbd6e2">Quantity</th>
                          <th align="center" style="padding:8px 24px;font-size:12px;font-weight:700;text-transform:uppercase;border:1px solid #cbd6e2">Unit Cost</th>
                          <th align="center" style="padding:8px 24px;font-size:12px;font-weight:700;text-transform:uppercase;border:1px solid #cbd6e2">Total</th>
                        </tr>
                        <tr>
                          <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                            <strong style="font-weight:600">Facit Smart Count Channel Licence</strong><br>
                          </td>
                          <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                            {{totalChannels}}<br>
                          </td>
                          <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                            <span style="white-space:nowrap">{{currencyIcon}}{{unitCost | numeral('0,0.00')}}</span>
                          </td>
                          <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                            <span style="white-space:nowrap">{{currencyIcon}}{{licenceCost | numeral('0,0.00')}}</span></td>
                          </tr>
                          <tr>
                            <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <strong style="font-weight:600">Discount</strong><br>
                            </td>
                            <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">

                            </td>
                            <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <span style="white-space:nowrap">20%</span>
                            </td>
                            <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <span style="white-space:nowrap">-{{currencyIcon}}{{discount | numeral('0,0.00')}}</span></td>
                            </tr>
                          <tr v-if=isRemoteSetup>
                            <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <strong style="font-weight:600">2 Hours Remote Setup</strong><br>
                            </td>
                            <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                              1<br>
                            </td>
                            <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <span style="white-space:nowrap">{{currencyIcon}}150.00</span>
                            </td>
                            <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <span style="white-space:nowrap">{{currencyIcon}}150.00</span>
                            </td>
                          </tr>
                          <tr v-if=isTrainingSession>
                            <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <strong style="font-weight:600">1 Day Training Session</strong><br>
                            </td>
                            <td align="left" style="padding:16px 24px;border:1px solid #cbd6e2">
                              1<br>
                            </td>
                            <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <span style="white-space:nowrap">{{currencyIcon}}250.00</span>
                            </td>
                            <td align="right" style="padding:16px 24px;border:1px solid #cbd6e2">
                              <span style="white-space:nowrap">{{currencyIcon}}250.00</span>
                            </td>
                          </tr>

                      </table>
                      <table cellpadding="0" border="0" cellspacing="0" width="100%">

                          <tr>
                            <td align="left" valign="middle" style="padding:0px 10px">
                              <table cellpadding="0" border="0" cellspacing="0" width="100%">

                                  <tr>
                                    <td align="right" valign="middle" style="padding:30px 0">
                                      <table cellpadding="0" border="0" cellspacing="0" width="40%" valign="middle" style="width:40%;min-width:40%">

                                          <tr>
                                            <td valign="middle">
                                              <table cellpadding="0" border="0" cellspacing="0" width="100%">

                                                  <tr>
                                                    <td align="left" valign="middle" style="padding:0"><span style="white-space:nowrap">Subtotal</span><br>
                                                      <span style="white-space:nowrap">VAT</span><br>
                                                      <strong style="font-weight:600"><span style="white-space:nowrap">Total Due</span><br></strong>
                                                    </td>
                                                  </tr>

                                              </table>
                                            </td>
                                            <td valign="middle">
                                              <table cellpadding="0" border="0" cellspacing="0" width="100%">

                                                  <tr>
                                                    <td align="right" valign="middle" style="padding:0">
                                                      <span style="white-space:nowrap">{{currencyIcon}}{{subTotal | numeral('0,0.00')}}</span><br>
                                                      <span style="white-space:nowrap">{{currencyIcon}}{{vat | numeral('0,0.00')}}</span><br>
                                                      <strong style="font-weight:600"><span style="white-space:nowrap">{{currencyIcon}}{{totalCost | numeral('0,0.00')}}</span><br></strong>
                                                    </td>
                                                  </tr>

                                              </table>
                                            </td>
                                          </tr>

                                      </table>
                                    </td>
                                  </tr>

                              </table>
                            </td>
                          </tr>

                      </table>
                      <table cellpadding="0" border="0" cellspacing="0" width="100%">
                        <tr>
                          <td align="left" valign="middle" style="padding:16px 30px">
                            <span v-if="bPound">
                              <strong>Pay by wire transfer:</strong><br>
                              Account Name: Facit Data Systems Ltd<br>
                              Account Type: British Pound<br>
                              Account No: 22148412<br>
                              Sort Code:  40-44-37<br>
                              IBAN: GB51 HBUK 4044 3722 1484 12<br>
                              SWIFT/BIC: HBUKGB4B<br>
                              <br>
                              Bank Name &amp; Address:<br>
                              HSBC<br>
                              05 Mount Pleasant Rd,<br>
                              Tunbridge Wells TN1 1QP<br>
                              United Kingdom
                            </span>
                            <span v-if="euro">
                              <strong>Pay by wire transfer:</strong><br>
                              Account Name: Facit Data Systems Ltd<br>
                              Account Type: Euro<br>
                              Account No: 85920565<br>
                              Sort Code:  40-12-76<br>
                              IBAN: GB98 HBUK 4012 7685 9205 65<br>
                              SWIFT/BIC: HBUKGB4B<br>
                              <br>
                              Bank Name &amp; Address:<br>
                              HSBC<br>
                              05 Mount Pleasant Rd,<br>
                              Tunbridge Wells TN1 1QP<br>
                              United Kingdom
                            </span>
                            <span v-if="rotw">
                              <strong>Pay by wire transfer:</strong><br>
                              Account Name: Facit Data Systems Ltd<br>
                              Account Type: US Dollar<br>
                              Account No: 85920573<br>
                              Sort Code:  40-12-76<br>
                              IBAN: GB76 HBUK 4012 7685 9205 73<br>
                              SWIFT/BIC: HBUKGB4B<br>
                              <br>
                              Bank Name &amp; Address:<br>
                              HSBC<br>
                              05 Mount Pleasant Rd,<br>
                              Tunbridge Wells TN1 1QP<br>
                              United Kingdom
                            </span>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

              </table>
            </td>
          </tr>
        </table>
      </div>
      <div>
  <div>
    <br><br>
    <p class="text-center" style="font-size: 13px;">Willows 3, Mill Farm Courtyard, Beachampton, Milton Keynes, England, MK19 6DS<br>
    Tel: +44 (0)3700 610 498 Fax: +44 (0)3700 610 499 Email: info@facitdatasystems.com Website: www.facitdatasystems.com<br>
    Company Registration No: 09090054 VAT: 192 4162 10</p>
  </div>
</div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import VueRecaptcha from 'vue-recaptcha';
import FacitHeader from '@/components/header';
import moment from 'moment';

export default {
  name: 'quote',
  components: { FacitHeader },
  data() {
    const quoteNumber = this.$route.query.quoteNumber;
    return {
      quoteNumber: quoteNumber,
      firstName: '',
      lastName: '',
      company: '',
      address: '',
      postCode: '',
      emailAddress: '',
      totalChannels: '',
      isRemoteSetup: false,
      isTrainingSession: false,
      requestDate: '',
      country: '',
      moment: moment,
      licenceCost: '',
      subTotal: '',
      totalCost: '',
      discount: '',
      unitCost: '',
      purchasedOrderNo: '',
      vat: 0,
      currencyIcon: null,
      region: null,
      bPound: false,
      euro: false,
      rotw: false,
    };
  },
  created() {
    this.getData()
},
  methods: {
    async getData() {
      const getQuote = await API.get(`OrderNows?filter={"where": {"quoteNumber":"${this.quoteNumber}"}}`)
      const finalData = getQuote[0]
      let costValue = 0
      let vatValue = 0
      this.firstName = finalData.firstName
      this.lastName = finalData.lastName
      this.company = finalData.company
      this.address = finalData.address
      this.postCode = finalData.postcode
      this.totalChannels = finalData.channels
      this.emailAddress = finalData.emailAddress
      this.isRemoteSetup = finalData.remoteSetup
      this.isTrainingSession = finalData.trainingSession
      this.country = finalData.country
      this.requestDate = moment(finalData.requestDate).format('DD-MM-YYYY')
      this.region = finalData.region
      this.unitCost = finalData.unitCost
      this.purchasedOrderNo = finalData.purchaseOrder

      if (this.region === 'UK') {
        this.currencyIcon = '£'
        vatValue = 0.2
        this.bPound = true
      } else if (this.region === 'EU') {
        this.currencyIcon = '€'
        vatValue = 0
        this.euro = true
      } else {
        this.currencyIcon = '$'
        vatValue = 0
        this.rotw = true
      }

      costValue = finalData.channels * this.unitCost
      this.discount = 0.2 * costValue
      this.licenceCost = costValue
      let remoteSetupCost = this.isRemoteSetup ? 150:0
      let trainingSessionCost = this.isTrainingSession ? 250:0
      let subt = (costValue - this.discount) + remoteSetupCost + trainingSessionCost
      this.vat = vatValue * subt
      this.subTotal = subt
      let totalValue = subt + this.vat
      this.totalCost = totalValue
    },
    dashboard() {
      this.$router.push('peoplecounting');
    },
    support() {
      this.$router.push('facitSupport');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
  min-width: 100%;
  width: 100%;
}
.main-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
  width: 80%;
}
.logout {
  margin-top: 28px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/quote.vue